module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-main', {
    staticClass: "client-login-background"
  }, [_c('v-container', {
    staticClass: "fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "8",
      "lg": "4"
    }
  }, [_c('v-card', {
    staticClass: "elevation-12"
  }, [_c('v-toolbar', {
    attrs: {
      "height": "150",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "client-login-logo-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoPrimary,
      "alt": "Kobe"
    }
  })]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "title text-center"
  }, [_vm._v("Advertiser Login")]), _vm._v(" "), _c('v-form', [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.emailErrors,
      "prepend-icon": "person",
      "name": "login",
      "label": "Login",
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.$v.email.$touch()
      },
      "blur": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.passwordErrors,
      "id": "password",
      "prepend-icon": "lock",
      "name": "password",
      "label": "Password",
      "type": "password"
    },
    on: {
      "input": function($event) {
        return _vm.$v.password.$touch()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.checkCreds()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.checkCreds()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-center": "",
      "xs12": ""
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/forgot-password"
    }
  }, [_vm._v("Forgot password?")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "title text-center"
  }, [_vm._v("\n                For Influencers "), _c('br'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "depressed": "",
      "dark": "",
      "to": "login"
    }
  }, [_vm._v("\n                    Go to Influencer Login\n                  ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v("\n                By logging in, you confirm that you have read the\n                "), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/website-terms-use/",
      "target": "_blank"
    }
  }, [_vm._v("terms and conditions")]), _vm._v(" , that you understand them and that you agree to be bound by them.\n              ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "dark": "",
      "height": "auto",
      "color": "#1A1A1A"
    }
  }, [_c('v-row', {
    attrs: {
      "row": "",
      "wrap": "",
      "white--text": "",
      "text-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('u', [_vm._v("Singapore")]), _vm._v(" "), _c('br'), _vm._v("Contact:\n          "), _c('a', {
    attrs: {
      "href": "tel:+6562555662"
    }
  }, [_vm._v("6255 5662")]), _vm._v(" /\n          "), _c('a', {
    attrs: {
      "href": "mailto:creator@getkobe.com"
    }
  }, [_vm._v("creator@getkobe.com")]), _vm._v(" "), _c('br'), _vm._v("51 Goldhill Plaza #14-01 Singapore 308900\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center"
  }, [_c('br'), _vm._v("Website\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-terms-use"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(" and\n          "), _c('a', {
    attrs: {
      "href": "https://getkobe.com/website-privacy-policy"
    }
  }, [_vm._v("Privacy Policy")]), _vm._v(".\n          "), _c('br'), _vm._v("\n          All Rights Reserved © 2016-" + _vm._s(_vm.year) + " Kobe Global Technologies Pte Ltd\n        ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "white--text text-center mb-0 pt-2"
  }, [_vm._v("\n          Patent: "), _c('a', {
    attrs: {
      "href": "https://patentscope.wipo.int/search/en/detail.jsf?docId=SG235183686&_cid=P20-KEI88S-46965-1",
      "target": "_blank"
    }
  }, [_vm._v(" KOBE 11201807777W ℗ ")])])])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.loading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "#A3FF12",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d412c0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientLogin.vue
// module id = 2088
// module chunks = 0